import { render } from "./checkContent1226.vue?vue&type=template&id=3a045254&scoped=true&ts=true"
import script from "./checkContent1226.vue?vue&type=script&lang=ts"
export * from "./checkContent1226.vue?vue&type=script&lang=ts"

import "./checkContent1226.vue?vue&type=style&index=0&id=3a045254&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a045254"]])

export default __exports__